<template>
  <div id="main-box" class="page-content" :class="{bottom:list.length > 0}">
    <div class="table-box layui-body" style="left:0;">
      <div class="xblock layui-form">
        <div class="layui-input-inline country_select xblock-row">
          <select name="status" lay-verify="required" lay-filter="type_select">
            <option value="0">所有类型</option>
            <option :value="item.id" v-for="item in PackageType" v-text="item.name"></option>
          </select>
        </div>
        <div class="x-right xblock-row">
          <span class="x-right" v-if="count > 0" v-text="'共有数据：'+count+ '条'"></span>
          <span class="x-right" style="margin:0 15px;color: #999;">|</span>
          <span class="x-right" v-text="'可使用店铺：'+PackageInfo.shop_limit+ '个'"></span>
          <span class="x-right" style="margin:0 15px;color: #999;">|</span>
          <span class="x-right" v-text="'已授权店铺：'+PackageInfo.shop_count+ '个'"></span>
        </div>
        <div class="clear-both"></div>
      </div>

      <table class="layui-table">
        <thead>
          <tr>
            <th>编号</th>
            <th>类型</th>
            <th>名称</th>
            <th>支付方式</th>
            <th>支付金额</th>
            <th>到期时间</th>
            <th>创建时间</th>
          </tr>
        </thead>
        <tbody>
          <tr class="order_box" v-for="(item,index) in list" v-bind:key="index">
            <td v-text="item.out_trade_no"></td>
            <td>
              <i v-if="item.package_type">VIP服务</i>
              <i v-else>资源包</i>
            </td>
            <td v-text="item.name"></td>
            <td v-text="item.pay_method"></td>
            <td v-text="item.pay_money"></td>
            <td>
              <i v-if="item.expire_date" v-text="item.expire_date"></i>
              <i v-else>-</i>
            </td>
            <td v-text="item.order_date"></td>
          </tr>
        </tbody>
      </table>

      <!-- transition -->
      <K-Transition :isLoding="isLoding" v-if="isLoding || list.length < 1" style="margin-top: 16px;"></K-Transition>

    </div>

    <!-- 分页 -->
    <div class="page-box">
      <div id="pagebox" class="pagebox"></div>
    </div>

    <!-- loading -->
    <K-Loading v-if="loading"></K-Loading>

    <!-- toast -->
    <K-Toast :Toast="Toast" @ChangeToast="ChangeToast"></K-Toast>

    <!-- 确认框 -->
    <K-Confirm :Confirm="Confirm" @ConfirmBackFun="ConfirmBackFun"></K-Confirm>

  </div>
</template>

<script>
  var self, form, layer, laypage;
  import axios from 'axios'
  import Loading from '@/components/common/Loading.vue'
  import Toast from '@/components/common/Toast.vue'
  import Transition from '@/components/common/Transition.vue'
  import Confirm from '@/components/common/Confirm.vue'
  export default {
    name: 'Promote',
    components: {
      'K-Loading': Loading,
      'K-Toast': Toast,
      'K-Transition': Transition,
      'K-Confirm': Confirm,
    },
    data() {
      return {
        te: 0,
        isLoding: true,
        ishow: "none",
        loading: false,
        Toast: {
          state: false,
          type: 0,
          txt: null
        },
        Confirm: {
          state: false,
          txt: null
        },
        id: null,
        item: null,
        page: 1,
        count: 0,
        page_num: 20,
        total: 0,
        list: [],
        PackageType: [{
          id: 1,
          name: "VIP服务"
        }, {
          id: 2,
          name: "资源包"
        }],
        PackageInfo: {
          shop_limit: 0,
          shop_count: 0
        }
      }
    },
    mounted() {
      self = this;
      self.SetNavActive("上架", self.$route.name);
      let mid = self.$route.query.main_account_id
      let id = self.$route.query.shop_id
      let code = self.$route.query.code
      if (id) {
        self.store_shop_id(1, id, code);
      } else if (mid) {
        self.store_shop_id(2, mid, code);
      }

      layui.use(['form', 'layer', 'laypage'], function() {
        form = layui.form;
        layer = layui.layer;
        laypage = layui.laypage;

        //类型
        form.on('select(type_select)', function(data) {
          self.te = data.value;
          self.GetList();
        });

        form.render();

        self.GetList()
        self.GetUserPackage();
      });

    },
    methods: {
      ToastFun(type, txt) {
        self.Toast.state = true;
        self.Toast.type = type;
        self.Toast.txt = txt;
      },
      ChangeToast() {
        self.Toast.state = false;
      },
      store_shop_id(te, id, code) {
        self.loading = true;
        let param = new URLSearchParams()
        if (te == 1) {
          param.append('shop_id', id)
        } else {
          param.append('main_account_id', id)
        }
        param.append('code', code)
        axios({
          method: 'post',
          url: self.GetServerUrl() + "/get_shop_id/",
          data: param,
          headers: {
            'token': localStorage.getItem("ExShopee_token")
          }
        }).then(function(response) {

          //返回数据处理
          self.ReturnFuntion(self, response, function(datas) {
            self.ishow = "block";
            self.$router.push({
              path: "/Shop"
            });
            self.GetList();
            self.synchronize_orders(id); //同步订单
          }, false, true);

        }).catch(function(error) {
          self.loading = false;
          console.log(error);
        })
      },
      GetList() {
        let param = new URLSearchParams()
        param.append('package_item_type', self.te);
        param.append('num', self.page_num)
        self.isLoding = true;
        axios({
          method: 'post',
          url: self.GetServerUrl() + "/package_record/?page=" + self.page,
          data: param,
          headers: {
            'token': localStorage.getItem("ExShopee_token")
          }
        }).then(function(response) {
          self.isLoding = false;
          var json = response.data;
          var datas = json.datas;
          if (json.code == 200) {
            if (datas.page) {
              for (let i in datas.list) {
                datas.list[i].auth_time = self.timestampToTime(datas.list[i].auth_time)
              }
              self.list = datas.list;
              self.total = datas.total;
              self.count = datas.page.count;
              self.ShowPage(self, laypage, "GetList"); //分页
              $('.pagebox').show();
            }
          } else if (json.code == 401) {
            self.GoToPage("/");
          } else {
            self.list = [];
            self.count = 0; //页数
            $('.pagebox').hide();
          }

        }).catch(function(error) {
          self.isLoding = false;
          self.ToastFun(2, error); //弹窗提醒
        })

      },
      GetUserPackage() {
        let param = new URLSearchParams()
        axios({
          method: 'post',
          url: self.GetServerUrl() + "/user_package/",
          data: param,
          headers: {
            'token': localStorage.getItem("ExShopee_token")
          }
        }).then(function(response) {

          //返回数据处理
          self.ReturnFuntion(self, response, function(datas) {
            self.PackageInfo = datas;
          }, false, true);

        }).catch(function(error) {
          console.log(error);
        })
      },
      get_authorization() {
        self.loading = true;
        axios({
          method: 'post',
          url: self.GetServerUrl() + "/get_shop_authorization/",
          headers: {
            'token': localStorage.getItem("ExShopee_token")
          }
        }).then(function(response) {

          //返回数据处理
          self.ReturnFuntion(self, response, function(datas) {
            window.open(datas);
            layer.closeAll();
          }, false, true);

        }).catch(function(error) {
          self.loading = false;
          self.ToastFun(2, error); //弹窗提醒
        })
      },
      synchronize_orders(id) {
        self.loading = true;
        let param = new URLSearchParams()
        param.append('shop_id', id)
        axios({
          method: 'post',
          url: self.GetServerUrl() + "/synchronize_orders/",
          data: param,
          headers: {
            'token': localStorage.getItem("ExShopee_token")
          }
        }).then(function(response) {
          self.ishow = "none";

          //返回数据处理
          self.ReturnFuntion(self, response, function(datas) {
            self.Confirm.style = 1;
            self.Confirm.state = true;
            self.Confirm.txt = "订单导入成功，是否前往订单列表？"
          }, false, true);

        }).catch(function(error) {
          self.ishow = "none";
          self.loading = false;
          console.log(error);
        })
      },
      AddShop(title) {
        layer.open({
          type: 1,
          offset: '100px',
          title: "选择授权店铺类型",
          area: ['800px', '250px'],
          fixed: false, //不固定
          btn: ['店铺授权'],
          // btn: ['店铺授权', '查看我的店铺类型'],
          content: StoreAuthorization,
          success: function() {
            form.render();
          },
          yes: function(index, layero) {
            self.get_authorization();
          },
          btn2: function(index, layero) {
            window.open("https://exshopee.cn/privacy");
          }
        });
      },
      UpdateShop() {
        self.get_authorization();
      },
      ConfirmHint(te, item) {
        self.Confirm.style = 2;
        self.Confirm.state = true;
        if (te == 1) {
          self.Confirm.txt = "是否确认删除？"
        } else {
          self.Confirm.txt = "是否确认解除授权？"
        }
        self.item = item;
      },
      ConfirmBackFun(data) {
        self.Confirm.state = data.state;
        if (self.Confirm.style == 1) {
          if (data.state) {
            console.log(data.state)
            self.Confirm.state = false;
            self.isLogin = true;
            localStorage.setItem("ExShopee_HistoryURL", "Order");
            self.GoToPage('/Order?te=0'); // 路由跳转
          }
        } else {
          if (data.state) {
            self.Confirm.state = false;
            let param = new URLSearchParams()
            param.append('id', self.item.id)
            self.loading = true;
            axios({
              method: 'post',
              url: self.GetServerUrl() + "/del_shop/",
              data: param,
              headers: {
                'token': localStorage.getItem("ExShopee_token")
              }
            }).then(function(response) {

              //返回数据处理
              self.ReturnFuntion(self, response, function(datas) {
                self.GetList();
              }, false, true);

            }).catch(function(error) {
              self.loading = false;
              console.log(error);
            })
          }
        }

      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  td {
    padding: 18px 15px;
  }

  .country_select {
    width: 150px;
  }

  .promote-url {
    padding-left: 10px;
    line-height: 40px;
  }
</style>



// WEBPACK FOOTER //
// src/components/product/Purchased.vue